// Pure helper for the Admin Proxy Inventory tab.
// Kept separate from the component so it is importable for unit tests without
// pulling in AdminProxyPage.jsx's component tree (same convention as
// googleReviews.js / istToUtcIso.js).

// Dedicated IPv6 inventory is non-sharing by database constraint (see
// `proxy_ip_inventory`'s address-family check). Sharing status/controls are
// therefore only meaningful for IPv4 rows; this reads the row's actual
// `address_family` rather than inferring family from the IP text.
export function isDedicatedIpv6InventoryRow(item) {
  return item?.address_family === 'IPV6';
}
